<div class="mode" (click)="toggleMode()">
    <app-svg-icon [icon]="'moon'"></app-svg-icon>
</div>